// extracted by mini-css-extract-plugin
export default {"base":"src-loading-skeleton-module__base--KekrK","animated":"src-loading-skeleton-module__animated--uL7tr","fadeInOut":"src-loading-skeleton-module__fadeInOut--_hxP4"};